export const enum MatrixTrackingEvent {
  HELP_BUTTON_CLICKED = 'matrix-help-button-clicked',
  SIZE_DISTRIBUTION_USED = 'matrix-size-distribution-used',
  PREPACKS_USED = 'matrix-prepacks-used',
  PASTE_MULTI_SELECT_USED = 'matrix-paste-multi-select-used',
  MULTI_SELECT_USED_WITH_KEYBOARD = 'matrix-multi-select-used-with-keyboard',
}
